export default __webpack_public_path__ + "alberta-fab-document.d357a719b08858266ed9.svg";